import { Component, OnInit } from '@angular/core';
import { JobQuotationService } from '../../../../service/job-quotation.service';

@Component({
  selector: 'app-job-quotation-trace',
  templateUrl: './job-quotation-trace.component.html',
  styleUrls: ['./job-quotation-trace.component.less']
})
export class JobQuotationTraceComponent implements OnInit {

  jobQuotation: any = null;
  traces: any[] = null;

  constructor(
    private jobQuotationService: JobQuotationService) { }

  async ngOnInit() {
    if (this.jobQuotation == null) {
      return;
    }
    // 查找历史轨迹
    this.jobQuotationService.getTraceByJqno(this.jobQuotation.id).subscribe((data: any) => {
      this.traces = data;
    });
  }

}
